import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import CategoryView from '../views/Category.vue'
import CartView from '../views/Cart.vue'
import RegisterView from '../views/Register.vue'
import LoginView from '../views/Login.vue'
import CheckoutView from '../views/Checkout.vue'
import SearchView from '../views/Search.vue'
import OrderView from '../views/Order.vue'
import store from "../store";


import BrandStoreView from '../views/BrandStoreView.vue';
import BrandView from '../views/BrandView.vue';

//validation if not authenticated and redirect
const ifnotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next("/login");
    return;
  }
  next();
  return;
};

//validation if authenticated and redirect
const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated && from.path == "/") {
    next("/");
    return;
  }
  if (!store.getters.isAuthenticated && from.path != "/") {
    next();
    return;
  }
  if (!store.getters.isAuthenticated && from.path == "/") {
    next();
    return;
  }
  next("/");
  return;
};



const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: 'Sigma Farmers Market' },
  },
  {
    path: '/category/:id/:subid',
    name: 'category',
    component: CategoryView
  },
  {
    path: '/cart',
    name: 'cart',
    component: CartView
  },
  {
    path: '/orders',
    name: 'orders',
    component: OrderView,
    beforeEnter: ifnotAuthenticated
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/search/:name',
    name: 'search',
    component: SearchView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: CheckoutView,
    beforeEnter: ifnotAuthenticated
  },
  {
    path: '/brand-store/:brandname',
    name: 'brandstore',
    component: BrandStoreView
  },
  {
    path: '/brand/:brandname',
    name: 'brand',
    component: BrandView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})





export default router
